import ErrorBanner from "../ErrorBanner";
import withTouchOutsideDismissible from "../WithTouchOutsideDismissible";
import classnames from "classnames";
import styles from "./index.css";

const className = classnames(styles.errorBanner, styles.show);

export default withTouchOutsideDismissible({
  component: ErrorBanner,
  className,
  shouldRenderKey: "errorMessage"
});
